import { PlatformType } from 'lib-shared-legacy-types';
import { asn1, pkcs12, pki, util } from 'node-forge';


export function mapPlatform(platform: PlatformType | undefined): string {
  switch (platform) {
    case 'APNS':
      return 'Apple Push Notification service';
    case 'APNS_SANDBOX':
      return 'Apple Push Notification service (Sandbox)';
    case 'GCM':
      return 'Firebase Cloud Messaging';
    default:
      return 'Unknown platform';
  }
}

function extractBag(
  p12: pkcs12.Pkcs12Pfx,
  key: string,
): pkcs12.Bag | undefined {
  return p12.getBags({ bagType: key })?.[key]?.[0];
}

function getPemFromCert(cert: pki.Certificate): string {
  return pki.certificateToPem(cert);
}

function getPemFromKey(key: pki.PrivateKey): string {
  const asn1 = pki.privateKeyToAsn1(key);
  const wrapped = pki.wrapRsaPrivateKey(asn1);

  return pki.privateKeyInfoToPem(wrapped);
}

// PKCS 12 is an archive file format.
// It's internal storage containers called "SafeBags".
// Purpose behind this function to extract cert and private key in text based container format(PEM).
export function extractPkcs12(
  buffer: ArrayBuffer,
  password?: string,
): { privateKey: string; cert: string } | null {
  try {
    // deserialize byte buffer to an ASN.1 object
    const p12Asn1 = asn1.fromDer(new util.ByteStringBuffer(buffer));
    // decrypt p12 (with/without password)
    const p12 = pkcs12.pkcs12FromAsn1(p12Asn1, false, password);
    // Exctract cert and private key from certificate
    const certBag = extractBag(p12, pki.oids.certBag);
    const keyBag = extractBag(p12, pki.oids.pkcs8ShroudedKeyBag);
    if (!keyBag?.key || !certBag?.cert) {
      return null;
    }

    // Generate PEM for both
    return {
      privateKey: getPemFromKey(keyBag.key),
      cert: getPemFromCert(certBag.cert),
    };
  } catch (e) {
    console.error('Failed to extract certificate', e);
    return null;
  }
}
